// Header animation

window.onscroll = function() {
  growShrinkLogo()
};

var Logo = document.getElementsByClassName("desktop-logo-image")[0];
var Header = document.getElementsByClassName("site-header-main")[0];
var Strapline = document.getElementsByClassName("logo-strapline")[0];
var endOfDocumentTop = 100;
var size = 0;

function growShrinkLogo() {
var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  if (size == 0 && scroll > 155) {
    Logo.style.transition = "0.4s";
    Logo.style.height = "48px";
    Strapline.style.transition = "0.4s";
    Strapline.style.display = "none";
    size = 1;
  } else if(size == 1 && scroll <= 95){
    Logo.style.height = "96px";
    Strapline.style.display = "block";
   size = 0;
  }
}

// Hero utility animation on mobile

// $(function(x){
//   	//this sets an infinite timer that launches the function after
//     //5 seconds, and keeps doing it every 5 seconds infinitely.
//     if (x.matches) { // If media query matches
//     	setInterval(TogglePanels,5000);
//   	}
// });

// function TogglePanels(x){
//   if (x.matches) {
//     var $first;
//     var $second;
//     //check which one is visible, to fade it out first:
//     if($("#utility1").is(":visible")){
//       $first=$("#utility1");
//       $second=$("#utility2");
//     }else{
//       $first=$("#utility2");
//       $second=$("#utility1");
//     }
  
//    //fade out the visible panel
//    $first.fadeToggle("slow",function(){
//        //this is a callback function that runs when the fading is complete.
//        //fade in the invisible panel
//         $second.fadeToggle("slow");
//    }); 
//   }
// }
